/* KyroLabs header interaction — vanilla, deferred, no dependencies.
   Nav underline + all hovers are now pure CSS (see kyro-custom.css).
   JS only handles two things CSS can't: sticky-header state + cart bump. */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Sticky header — glass blur past 8px scroll (rAF-throttled) */
  function initStickyHeader() {
    var header = document.querySelector(".header-menu");
    if (!header) return;
    var ticking = false;
    function update() {
      header.classList.toggle("is-scrolled", (window.scrollY || window.pageYOffset) > 8);
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* Cart bump on add-to-cart (Shopify updates the bubble via ajax) */
  function initCartBump() {
    var cart = document.querySelector(".action__cart");
    if (!cart || reduceMotion) return;
    var obs = new MutationObserver(function () {
      cart.classList.remove("is-bumped");
      void cart.offsetWidth; // restart animation
      cart.classList.add("is-bumped");
    });
    obs.observe(cart, { childList: true, subtree: true, characterData: true });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initStickyHeader();
    initCartBump();
  });
})();

/* Footer email-signup: AJAX submit so the success message REPLACES the input bar
   (no reload) and clears on refresh (purely client-side state). Degrades to a
   native form post if JS/fetch fails. */
(function () {
  "use strict";
  if (!("customElements" in window)) return;

  function EmailSignupForm() { return Reflect.construct(HTMLElement, [], EmailSignupForm); }
  EmailSignupForm.prototype = Object.create(HTMLElement.prototype);
  EmailSignupForm.prototype.constructor = EmailSignupForm;

  EmailSignupForm.prototype.connectedCallback = function () {
    this.form = this.querySelector("form");
    this.inputGroup = this.querySelector(".email-signup__input-group");
    this.success = this.querySelector('[id^="Email-signup__message-success"]');
    if (!this.form || !this.inputGroup || !this.success) return;
    this.form.addEventListener("submit", this.onSubmit.bind(this));
  };

  EmailSignupForm.prototype.onSubmit = function (event) {
    event.preventDefault();
    var self = this;
    var btn = this.form.querySelector('button[type="submit"], [type="submit"]');
    if (btn) btn.disabled = true;

    fetch(this.form.action, { method: "POST", body: new FormData(this.form) })
      .then(function (res) {
        return res.text().then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          // The success node is ALWAYS server-rendered hidden (so a refresh never
          // shows it). So detect failure instead: an error node means it failed.
          var remoteError = doc.querySelector('[id^="Email-signup__message-error"]');
          if (res.ok && !remoteError) {
            self.inputGroup.hidden = true;
            self.success.hidden = false;
            try { self.success.focus(); } catch (e) {}
          } else {
            self.nativeFallback();
          }
        });
      })
      .catch(function () { self.nativeFallback(); })
      .then(function () { if (btn) btn.disabled = false; });
  };

  EmailSignupForm.prototype.nativeFallback = function () {
    try { HTMLFormElement.prototype.submit.call(this.form); } catch (e) {}
  };

  if (!customElements.get("email-signup-form")) {
    customElements.define("email-signup-form", EmailSignupForm);
  }
})();

/* Cart RUO gate: checkout (and accelerated buttons) stay locked until the
   confirmation box is ticked. Re-syncs when the cart drawer re-renders. */
(function () {
  "use strict";

  function ctasFor(box) {
    var wrap = box.closest(".kyro-ruo");
    if (!wrap || !wrap.parentElement) return null;
    return wrap.parentElement.querySelector(".cart__ctas");
  }

  function apply(box) {
    var ctas = ctasFor(box);
    if (!ctas) return;
    var btn = ctas.querySelector('#checkout, [name="checkout"]');
    var locked = !box.checked;
    ctas.classList.toggle("kyro-ctas-locked", locked);
    if (btn) {
      // Never re-enable on an empty cart — Shopify disables it for that reason.
      if (locked) {
        btn.disabled = true;
        btn.setAttribute("aria-disabled", "true");
      } else if (btn.dataset.kyroEmpty !== "1") {
        btn.disabled = false;
        btn.removeAttribute("aria-disabled");
      }
    }
  }

  function syncAll() {
    var boxes = document.querySelectorAll("[data-kyro-ruo]");
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var ctas = ctasFor(box);
      if (ctas) {
        var btn = ctas.querySelector('#checkout, [name="checkout"]');
        // Remember a server-rendered disabled state (empty cart) once.
        if (btn && !btn.dataset.kyroSeen) {
          btn.dataset.kyroSeen = "1";
          btn.dataset.kyroEmpty = btn.disabled ? "1" : "0";
        }
      }
      apply(box);
    }
  }

  document.addEventListener("change", function (e) {
    var t = e.target;
    if (t && t.matches && t.matches("[data-kyro-ruo]")) apply(t);
  });

  // Cart drawer / cart section re-render swaps the DOM — re-sync when it does.
  var pending = false;
  var obs = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () { pending = false; syncAll(); });
  });

  function start() {
    syncAll();
    obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
